import { browser } from "$app/environment";
import { base } from "$app/paths";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
        return twMerge(clsx(inputs));
}

export function resolveAssetUrl(assetUrl: string) {
        if (assetUrl.startsWith("http")) {
                return assetUrl;
        }

        if (browser && typeof window !== "undefined") {
                return new URL(`${base}${assetUrl}`, window.location.origin).href;
        }

        return `${base}${assetUrl}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChild<T> = T extends { child?: any } ? Omit<T, "child"> : T;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChildren<T> = T extends { children?: any } ? Omit<T, "children"> : T;
export type WithoutChildrenOrChild<T> = WithoutChildren<WithoutChild<T>>;
export type WithElementRef<T, U extends HTMLElement = HTMLElement> = T & { ref?: U | null };
